import styles from './apiTable.module.css';

function TableButton({
    children,
    popoverText,
    onClick,
    props
}) {

    return (
        <button
            type="button"
            className={styles.tableButton}
            onClick={onClick}
            title={popoverText}
            style={{ ...props }}>
            {children}
        </button>
    )
}

export default TableButton;